
export const FETCH_POST="FETCH_POST";
export const CREATE_POST="CREATE_POST";
export const LIKE_POST="LIKE_POST";
export const DELETE_POST="DELETE_POST";